import { HeaderThElement } from "@progress/kendo-react-data-tools";
import Tooltip from "../../forms/Tooltip";

const HeaderCell = (headerProps) => {
  const { schemaItem } = headerProps
  const hasFilter = headerProps.columnMenuWrapperProps.filter?.filters.some(filter => filter.field === headerProps.columnMenuWrapperProps.column.field);

  return (
    <HeaderThElement
    {...headerProps.thProps}
    title={schemaItem?.tooltip}
    className={`headerCell ${headerProps.thProps.className || ""} ${schemaItem?.className || ""} ${hasFilter ? "column-menu-filtered" : ""}`}
    >
      <Tooltip
        anchorElement="target"
        openDelay={0}
        position="top"
        parentTitle={true}
        filter={(el) => el.className !== "k-column-resizer"}
        onPosition={(event) => {
          const th = event?.targetElement?.closest('th');
          if(!th) return { top: event.mouseTop - 50, left: event.mouseLeft - 25 };
          const rect = th.getBoundingClientRect();
          return ({
            top: rect.top - 32,//32 = tooltip height
            left: rect.left,
          })
        }}
      >
        {headerProps.children}
      </Tooltip>
    </HeaderThElement>
  )
}

export default HeaderCell;